import { IDroppedItem } from 'modules/LayersSidebar/LayersSidebar.interfaces';
import { FC, memo } from 'react';
import { DragDropContext, Draggable, Droppable } from 'react-beautiful-dnd';

import styles from './DraggableFlatlist.module.scss';

interface IDraggableFlatlistProps<T> {
  droppableId: string;
  className?: string;
  list: T[];
  handleDropItem: (droppedItem: IDroppedItem) => void;
  ListItem: FC<T>;
  isDragDisabled: boolean;
  onDragStart: (data) => void;
}

const DraggableFlatlist = <T extends { id: string; isHidden?: boolean }>({
  droppableId,
  className,
  list,
  handleDropItem,
  ListItem,
  isDragDisabled,
  onDragStart,
}: IDraggableFlatlistProps<T>): JSX.Element => {
  const handleDrop = (droppedItem): void => {
    handleDropItem(droppedItem as IDroppedItem);
  };

  return (
    <DragDropContext onDragEnd={handleDrop} onDragStart={onDragStart}>
      <Droppable droppableId={droppableId}>
        {(provided) => (
          <div
            className={className ?? styles['list-container']}
            {...provided.droppableProps}
            ref={provided.innerRef}
          >
            {list.map((item, index) => {
              return (
                <div key={item.id}>
                  <Draggable
                    draggableId={item.id}
                    index={index}
                    isDragDisabled={isDragDisabled}
                  >
                    {(provided) => (
                      <div
                        className={styles['item-container']}
                        ref={provided.innerRef}
                        {...provided.dragHandleProps}
                        {...provided.draggableProps}
                      >
                        <ListItem {...item} />
                      </div>
                    )}
                  </Draggable>
                </div>
              );
            })}
            {provided.placeholder}
          </div>
        )}
      </Droppable>
    </DragDropContext>
  );
};

export default memo(DraggableFlatlist);
